import LectureLessonListModuleListModelBase from '../_generated/modelBases/lecture-lesson-list-module-list-model-base';

export default class LectureLessonListModuleListModel extends LectureLessonListModuleListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
